import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../contexts/AuthContext";

const AuthCallback = () => {
  const { processGoogleSession, checkAuth } = useAuth();
  const hasProcessed = useRef(false);
  const [status, setStatus] = useState("processing");
  const [errorDetail, setErrorDetail] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Get session_id from hash
      const hash = window.location.hash;
      console.log("Auth callback - Hash:", hash);
      
      // Try multiple patterns to extract session_id
      let sessionId = null;
      
      // Pattern 1: #session_id=xxx
      const match1 = hash.match(/session_id=([^&]+)/);
      if (match1) sessionId = match1[1];
      
      // Pattern 2: #/session_id=xxx (sometimes router adds /)
      if (!sessionId) {
        const match2 = hash.match(/\/session_id=([^&]+)/);
        if (match2) sessionId = match2[1];
      }
      
      // Pattern 3: Check URL search params as fallback
      if (!sessionId) {
        const params = new URLSearchParams(window.location.search);
        sessionId = params.get('session_id');
      }
      
      console.log("Auth callback - Extracted session_id:", sessionId ? sessionId.substring(0, 10) + "..." : "null");
      
      if (sessionId) {
        try {
          setStatus("authenticating");
          console.log("Auth callback - Calling processGoogleSession...");
          const userData = await processGoogleSession(sessionId);
          console.log("Auth callback - User data received:", userData?.email);
          
          // Wait a bit for cookie to be set
          await new Promise(resolve => setTimeout(resolve, 500));
          
          // Force re-check auth to ensure user is set
          console.log("Auth callback - Checking auth...");
          await checkAuth();
          
          setStatus("success");
          console.log("Auth callback - Success! Redirecting to dashboard...");
          
          // Use window.location for a hard redirect to ensure state is fresh
          setTimeout(() => {
            window.location.href = "/dashboard";
          }, 500);
        } catch (error) {
          console.error("Auth callback error:", error);
          console.error("Error response:", error.response?.data);
          setErrorDetail(error.response?.data?.detail || error.message);
          setStatus("error");
          setTimeout(() => {
            window.location.href = "/";
          }, 3000);
        }
      } else {
        console.log("Auth callback - No session_id found in URL");
        setStatus("no_session");
        setErrorDetail("session_id manquant dans l'URL");
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);
      }
    };

    processSession();
  }, [processGoogleSession, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-yellow-50">
      <div className="text-center p-8 bg-white rounded-2xl shadow-lg max-w-md">
        <div className={`w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center ${
          status === "error" ? "bg-red-100" : status === "success" ? "bg-green-100" : "bg-orange-100"
        }`}>
          {status === "error" ? (
            <span className="text-3xl">❌</span>
          ) : status === "success" ? (
            <span className="text-3xl">✅</span>
          ) : (
            <div className="w-8 h-8 border-4 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
          )}
        </div>
        <p className="text-lg font-medium text-gray-800">
          {status === "processing" && "Connexion en cours..."}
          {status === "authenticating" && "Authentification Google..."}
          {status === "success" && "Connexion réussie !"}
          {status === "error" && "Erreur de connexion"}
          {status === "no_session" && "Session invalide"}
        </p>
        {errorDetail && (
          <p className="text-sm text-red-500 mt-2">{errorDetail}</p>
        )}
        <p className="text-sm text-gray-500 mt-2">
          {status === "success" && "Redirection vers votre compte..."}
          {(status === "error" || status === "no_session") && "Redirection vers l'accueil..."}
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
